module.exports = __webpack_public_path__ + "img/spfclf.2638bf61.jpg";